<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="sec-20"><section class="chapter" epub:type="chapter" id="section_level_h1_01" role="doc-chapter" title="Peace"><h1 class="chapter2" id="pz20-1"><a href="#/contents#ba_04" id="ab_04"><b>Peace</b></a></h1>
<p id="pz20-3">You will keep him in perfect peace,</p>
<p id="pz20-4">Whose mind is stayed on You,</p>
<p id="pz20-5">Because he trusts in You.</p>
<p class="right" id="pz20-6"><em>Isaiah 26:3</em></p>
<p id="pz20-7">But now in Christ Jesus you who once were far off have been brought near by the blood of Christ.</p>
<p id="pz20-8">For He Himself is our peace, who has made both one, and has broken down the middle wall of separation.</p>
<p class="right" id="pz20-9"><em>Ephesians 2:13, 14</em></p>
<p id="pz20-10">Be anxious for nothing, but in everything by prayer and supplication, with thanksgiving, let your requests be made known to God;</p>
<p id="pz20-11">and the peace of God, which surpasses all understanding, will guard your hearts and minds through Christ Jesus.</p>
<p class="right" id="pz20-12"><em>Philippians 4:6, 7</em></p>
<p id="pz20-13">L<span class="smallcaps">ORD</span>, You will establish peace for us,</p>
<p id="pz20-14">For You have also done all our works in us.</p>
<p class="right" id="pz20-15"><em>Isaiah 26:12</em></p>
<p id="pz21-1">For unto us a Child is born,</p>
<p id="pz21-2">Unto us a Son is given;</p>
<p id="pz21-3">And the government will be upon His shoulder.</p>
<p id="pz21-4">And His name will be called Wonderful, Counselor,</p>
<p id="pz21-6">Mighty God,</p>
<p id="pz21-7">Everlasting Father, Prince of Peace.</p>
<p id="pz21-8">Of the increase of His government and peace there will be no end,</p>
<p id="pz21-9">Upon the throne of David and over His kingdom,</p>
<p id="pz21-10">To order it and establish it with judgment and justice from that time forward, even forever.</p>
<p id="pz21-11">The zeal of the L<span class="smallcaps">ORD</span> of hosts will perform this.</p>
<p class="right" id="pz21-12"><em>Isaiah 9:6, 7</em></p>
<p id="pz21-13">And the God of peace will crush Satan under your feet shortly. The grace of our Lord Jesus Christ be with you. Amen.</p>
<p class="right" id="pz21-14"><em>Romans 16:20</em></p>
<p id="pz21-15">The things which you learned and received and heard and saw in me, these do, and the God of peace will be with you.</p>
<p class="right" id="pz21-16"><em>Philippians 4:9</em></p>
<p id="pz22-1">Therefore, having been justified by faith, we have peace with God through our Lord Jesus Christ.</p>
<p class="right" id="pz22-2"><em>Romans 5:1</em></p>
<p id="pz22-3">And let the peace of God rule in your hearts, to which also you were called in one body; and be thankful.</p>
<p class="right" id="pz22-4"><em>Colossians 3:15</em></p>
<p id="pz22-5">I will both lie down in peace, and sleep;</p>
<p id="pz22-6">For You alone, O L<span class="smallcaps">ORD</span>, make me dwell in safety.</p>
<p class="right" id="pz22-7"><em>Psalm 4:8</em></p>
<p id="pz22-8">The L<span class="smallcaps">ORD</span> will give strength to His people;</p>
<p id="pz22-9">The L<span class="smallcaps">ORD</span> will bless His people with peace.</p>
<p class="right" id="pz22-10"><em>Psalm 29:11</em></p>
<p id="pz22-11">Peace I leave with you, My peace I give to you; not as the world gives do I give to you. Let not your heart be troubled, neither let it be afraid.</p>
<p class="right" id="pz22-12"><em>John 14:27</em></p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter04.vue?1a57ab2e